import { render, staticRenderFns } from "./ImportOrdersPage.vue?vue&type=template&id=114c25e6&scoped=true&"
import script from "./ImportOrdersPage.vue?vue&type=script&lang=js&"
export * from "./ImportOrdersPage.vue?vue&type=script&lang=js&"
import style0 from "./ImportOrdersPage.vue?vue&type=style&index=0&id=114c25e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114c25e6",
  null
  
)

export default component.exports